import React from "react";
import { Link } from "react-router-dom";
import { FaUsers, FaCalendarDay, FaChartLine, FaFileInvoiceDollar } from "react-icons/fa";

const tiles = [
  { to: "/suppliers", label: "Προμηθευτές", icon: FaUsers, desc: "Διαχείριση προμηθευτών" },
  { to: "/daily-reports", label: "Απολογισμός Ημέρας", icon: FaCalendarDay, desc: "Έσοδα & έξοδα ημέρας" },
  { to: "/period-report", label: "Απολογισμός Περιόδου", icon: FaChartLine, desc: "Σύνοψη ανά μήνα" },
  { to: "/ekkathariseis", label: "Εκκαθαρίσεις", icon: FaFileInvoiceDollar, desc: "Προμήθειες & τιμές" },
];

const HomePage = () => (
  <div className="flex-1 overflow-y-auto px-4 py-6">
    <div className="mb-6 flex flex-col items-center text-center">
      <img src="/fish.svg" alt="" className="h-16 w-16" />
      <h2 className="mt-2 text-2xl font-extrabold tracking-widest text-brand-700">ΛΙΝΟΣ</h2>
      <p className="text-slate-500">Καλώς ήρθατε — επιλέξτε ενότητα</p>
    </div>

    <div className="grid grid-cols-2 gap-3">
      {tiles.map(({ to, label, icon: Icon, desc }) => (
        <Link
          key={to}
          to={to}
          className="flex flex-col items-center rounded-2xl border border-brand-600/10 bg-white p-5 text-center
                     shadow-card transition active:scale-95 hover:shadow-card-hover"
        >
          <div className="mb-3 flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-50 text-brand-600">
            <Icon size={26} />
          </div>
          <div className="font-semibold text-slate-800">{label}</div>
          <div className="mt-1 text-xs text-slate-400">{desc}</div>
        </Link>
      ))}
    </div>
  </div>
);

export default HomePage;
